export const MuiToggleButtonGroup = (palette) => ({
  styleOverrides: {
    root: {
      padding: 4,
      borderRadius: 99,
      gap: 2,
      backgroundColor: palette.neutral[100],
    },
  },
});

export const MuiToggleButton = (palette) => ({
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      textTransform: 'capitalize',
      border: 0,
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
      '&:hover': {
        backgroundColor: '#ffffff',
        borderRadius: 99,
      },
      '&.Mui-selected': {
        color: palette.primary.main,
        backgroundColor: '#ffffff',
        borderRadius: 99,
        boxShadow: '0 1px 2px 0 rgba(28, 39, 49, 0.08)',
        '&:hover': {
          backgroundColor: '#ffffff',
          borderRadius: 99,
        },
      },
    },
  },
});
